import { takeLatest, all, put } from "redux-saga/effects";
import * as calls from "./calls";
import * as reducerActions from "../../reducers/nivelesReducer/actions";
import * as Notifications from "../../components/Common/notification";
import * as layoutActions from "../../reducers/layoutReducer/actions";

function* genGetAllNiveles() {
  try {
    yield put(layoutActions.setLoading({ show: true, message: "Obteniendo niveles" }));
    let niveles = yield calls.GetAllNiveles();
    yield put(reducerActions.setNiveles(niveles));
  } catch (error) {
    if (error.Message) {
      return;
    }
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genGetNivel(e) {
  try {
    yield put(layoutActions.setLoading({ show: true, message: "Cargando nivel" }));
    let nivel = yield calls.getNivel(e.payload.id);
    yield put(reducerActions.saveNivel(nivel));
  } catch (error) {
    if (error.message) {
      return;
    }
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genGetNivelByCodigo(e) {
  try {
    yield put(layoutActions.setLoading({ show: true, message: "Cargando nivel" }));
    let nivel = yield calls.getNivelByCodigo(e.payload.codigo);
    yield put(reducerActions.saveNivel(nivel));
  } catch (error) {
    if (error.Message) {
      return;
    }
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genGetNivelByNombre(e) {
  try {
    yield put(layoutActions.setLoading({ show: true, message: "Cargando nivel" }));
    let nivel = yield calls.getNivelByNombre(e.payload.descripcion);
    yield put(reducerActions.saveNivel(nivel));
  } catch (error) {
    if (error.Message) {
      return;
    }
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genSaveNivel(e) {
  try {
    yield calls.saveNivel(e.payload);
    if (e.payload.idNivel !== 0) {
      Notifications.showSuccess("Nivel actualizada");
    } else {
      Notifications.showSuccess("Nivel creada");
    }
    window.history.back();
  } catch (e) {
    Notifications.showError(e.error);
  }
}

function* genDeleteNivel(e) {
  try {
    yield put(layoutActions.setLoading({ show: true, message: "Eliminando nivel" }));
    yield calls.deleteNivel(e.payload.idNivel);
    yield put(layoutActions.setLoading({ show: false }));
    Notifications.showSuccess("Nivel eliminado");
    yield put(reducerActions.sagaGetNiveles());
  } catch (error) {
    yield put(layoutActions.setLoading({ show: false }));
    Notifications.showError(error.message || "Error al eliminar el nivel");
  }
}

function* defaultSaga() {
  yield all([
    takeLatest(reducerActions.SAGA_GET_NIVELES, genGetAllNiveles),
    takeLatest(reducerActions.SAGA_GET_NIVEL, genGetNivel),
    takeLatest(reducerActions.SAGA_GET_NIVEL_BY_CODIGO, genGetNivelByCodigo),
    takeLatest(reducerActions.SAGA_GET_NIVEL_BY_NOMBRE, genGetNivelByNombre),
    takeLatest(reducerActions.SAGA_SAVE_NIVEL, genSaveNivel),
    takeLatest(reducerActions.SAGA_ELIMINAR_NIVEL, genDeleteNivel),
  ]);
}

export const sagas = [defaultSaga];
